import { db } from 'boot/firebase';
import { collection, collectionGroup, getDocs, orderBy, query, where } from 'firebase/firestore';
import { logEvent } from 'src/utils/LogEvent';

import GenericDB from './generic-db';

export default class PromptLevelsDB extends GenericDB {
  constructor(promptLevelTemplateId = null) {
    super('', 'promptLevelTemplates.promptLevels');
    this.setPromptLevelTemplateId(promptLevelTemplateId);
  }

  setPromptLevelTemplateId(promptLevelTemplateId) {
    this.promptLevelTemplateId = promptLevelTemplateId;
  }

  getCollectionRef() {
    return collection(db, 'promptLevelTemplates', this.promptLevelTemplateId, 'promptLevels');
  }

  // We can't use the generic readAll method here because we need to get the parent id of the promptLevels
  // eslint-disable-next-line class-methods-use-this
  async readByClinic(clinicId) {
    try {
      const promptLevelsQuery = query(
        collectionGroup(db, 'promptLevels'),
        where('clinic', '==', clinicId),
        orderBy('order'),
      );

      const promptLevelsData = await getDocs(promptLevelsQuery);

      return promptLevelsData.docs.map((doc) => {
        return {
          ...doc.data(),
          id: doc.id,
          promptLevelTemplateId: doc.ref.parent.parent.id,
        };
      });
    } catch (err) {
      console.error(err);
      logEvent(err);
      return [];
    }
  }
}
